import React, { useState, useEffect, useRef } from 'react'
import ReportCardPDFAndroid from './reportCardPDFAndroid.js';
import { getProgressReportSvc, getLogoSvc, getPrinciSignSvc, getValidationDtlsSvc, viewSignSvc } from './progressReportSvc.js';
import { toast, ToastContainer } from 'react-toastify';



const ProgressReportSliderAndroid = (props) => {

  const { heading, sectionId, syllabusId, clsSection,
    staffId, nextClass, showLoader, hideLoader } = props;

  const [lstReportCard, setLstReportCard] = useState([]);
  const [logoUrl, setLogoUrl] = useState('');
  const [imageUrl, setImageUrl] = useState('');
  const [flgValidated, setFlgValidated] = useState(false);
  const [teacherSignUrl, setTeacherSignUrl] = useState(null);
  const [result, setResult] = useState("");


  useEffect(() => {
    // console.log("progressReportSlider Called heading ", heading, ", sectionId ", sectionId);
    // console.log("sectionId ", sectionId, ", staffId", staffId, ", nextClass", nextClass);
    if (staffId) {
      viewSign(staffId);
    } else {
      setTeacherSignUrl(null);
    }
    if (sectionId && syllabusId) {
      getPrinciSignSvc(cbPrinciSign);
      getLogoSvc(cbLogoResponse);
      getProgressReport(sectionId, syllabusId);
    }
  }, [sectionId, syllabusId, staffId]);
  
  useEffect(() => {
    // console.log("progressReportSlider Called nextClass ", nextClass);
    if (nextClass && nextClass !== "") {
      setResult("Promoted to " + nextClass);
    } else {
      setResult("");
    }
  }, [nextClass]);

  function viewSign(userId) {
    // console.log('viewSign called');
    showLoader();
    viewSignSvc(userId, cbViewSignResp)
  }

  function cbViewSignResp(url, response) {
    // console.log(url)
    if (!url) {
      if (response.SvcStatus === 'Failure') {
        toast.error(response.SvcMsg)
      }
    } else {
      setTeacherSignUrl(url)
    }
    hideLoader();
  }

  function cbPrinciSign(imageUrl) {
    setImageUrl(imageUrl)
  }
  function cbLogoResponse(imageUrl) {
    // console.log("cbLogoResponse called, imageUrl", imageUrl);
    setLogoUrl(imageUrl)
  }

  const getProgressReport = (pSectionId, pSyllabusId) => {
    showLoader();
    getProgressReportSvc(pSectionId, pSyllabusId, progressReportResponse);
  }

  const progressReportResponse = (data) => {
    // console.log("progressReportResponse called, data", data);
    let obj = data;
    if (obj.status === 'Success') {
      setLstReportCard(obj.lstReportCardObj);
    }
    else {
      if (obj.message == 'You are not logged in') {
        setTimeout(function () {
          window.location.href = "/";
        }, 2000);
        return false;
      }
      else if (obj.message == 'Your Session is expired, login again') {
        setTimeout(function () {
          window.location.href = "/";
        }, 2000);
        return false;
      } else {
        toast.error(obj.message);
      }
    }
    hideLoader();
  }

  const getValidationDtls = (nSectionId, nExamId) => {
    // console.log("getValidationDtls called, nSectionId", nSectionId);
    // console.log("nExamId", nExamId);
    showLoader();
    getValidationDtlsSvc(nSectionId, nExamId, validationDtlsResponse);
  }

  const validationDtlsResponse = (data) => {
    // console.log("validationDtlsResponse called, data", data);
    let obj = data;
    if (obj.status === 'Success') {
      // console.log("obj.examScoreValidationDtls", obj.examScoreValidationDtls);
      setFlgValidated(obj.examScoreValidationDtls.validatedById !== 0);
    }
    else {
      handleSessionErrors(obj.message);
    }
    hideLoader();
  }

  const handleSessionErrors = (message) => {
    if (message === 'You are not logged in') {
      toast.error('You are not logged in. Redirecting to login page...');
      setTimeout(() => {
        window.location.href = "/";
      }, 2000);
      return true;
    } else if (message === 'Your Session is expired, login again') {
      toast.error('Your session has expired. Redirecting to login page...');
      setTimeout(() => {
        window.location.href = "/";
      }, 2000);
      return true;
    } else {
      toast.error(message);
      return false;
    }
  };
  const closeSlider = async () => {
    await setLstReportCard([]);
    await setTeacherSignUrl(null);
    props.closePdf();
  }



  return (
    <div >
      {lstReportCard && lstReportCard.length ?
        <ReportCardPDFAndroid
          logoUrl={logoUrl}
          lstReportCard={lstReportCard}
          teacherSignUrl={teacherSignUrl}
          imageUrl={imageUrl}
          flgValidated={flgValidated}
          clsSection={clsSection}
          result={result}
          showLoader={showLoader}
          hideLoader={hideLoader}
          closePdf={props.closePdf}
        />
        : null
      }
    </div>
  );
}

export default ProgressReportSliderAndroid;